import { useStores } from 'hooks/useStores'

import { UserRole } from 'models/user'

export const OnlyViewHoc: React.FC = ({ children }) => {
  const { userStore } = useStores()
  const role = userStore.user?.role as UserRole

  if (role === UserRole.ONLY_VIEW) {
    return null
  }

  return <>{children}</>
}
